export function categoryPerPropertyNum(mindMapData, nodesCount) {
  mindMapData.forEach((item) => {
    // Get names of categories and properties
    const categories = item["Category (per property)"];
    const properties = item["Property"];

    // If they are not empty then add the category name to the list with the number of associated properties
    if (categories.trim() !== "" && properties.trim() !== "") {
      if (!nodesCount[categories]) {
        nodesCount[categories] = 0;
      }
      nodesCount[categories]++;
    }
  });
}

export function sortCategories(categoriesList) {
  // Sort category names in descending order
  // Highest number of properties to lowest number
  return Object.keys(categoriesList).sort(
    (a, b) => categoriesList[b] - categoriesList[a]
  );
}

export function sortNodeAlternation(
  categoryOrder,
  numCategories,
  sortedCategories
) {
  // Add the category names to array
  // Process: Add first index to array, then last index, then second index, then second to last index and so on until you get to the last category
  for (let i = 0; i < Math.floor(numCategories / 2); i++) {
    sortedCategories.push(categoryOrder[i]);
    sortedCategories.push(categoryOrder[numCategories - 1 - i]);
  }

  // If the category array is not even, then add the category in the middle to the end of the list
  if (numCategories % 2 !== 0) {
    sortedCategories.push(categoryOrder[Math.floor(numCategories / 2)]);
  }
}
